module.exports = __webpack_public_path__ + "static/governance-0c276d6d9df188193e3734d4296a4927.png";